id: '**Entity_NotSyncedNotification_[RelatedDetailEntity]_Detail_Transformation_Id**'
index: '**Entity_NotSyncedNotification_[RelatedDetailEntity]_Detail_Transformation_Index**'
name: '**Entity_NotSyncedNotification_[RelatedDetailEntity]_Detail_Transformation_Name**'
type: Nested_SQL
metadata:
  fieldName: '__details_[RelatedDetailEntityFieldName]'
  sql: |-
    SELECT [RelatedDetailEntityFieldNameFields]
    FROM [RelatedDetailEntityTable] v
    LEFT JOIN [EntityTable] s ON [Relationships]
    WHERE 
      s.__id = @hss_id::uuid
